<template>
    <div>
        <h1>Auditorías sin verificación</h1>
        <ul class="list-group">
            <li v-for="(item, index) in noVerificadas" :key="index" class="list-group-item">
                <div class="form-row">
                    <div class="form-group col-lg-12 col-md-12 col-sm-12 mb-12">
                        Usuario: {{item.usuario}} - Auditoria: {{item.nombre}}
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-lg-12 col-md-12 col-sm-12 mb-12 listaAcciones">
                        <div v-if="item.nota" class="conNotas">Con notas</div>
                        <div v-if="!item.nota" class="sinNotas">Sin notas</div>
                        <router-link style="display: contents" :to="{name: 'Editar', params: {id: item.id}}">
                            <div class="btnTableVer">Ver</div>
                        </router-link>
                        <div @click="(modalVerificacion.item = item.id), (modalVerificacion.estado = true)" class="btnTableConfirmar">Confirmar</div>
                        <div @click="(modal.item = item.id), (modal.estado = true)" class="btnTableEliminar">Eliminar</div> 
                    </div>
                </div>
            </li>
        </ul>
        <div>
            <mdb-modal size="sm" :show="this.modal.estado" @close="confirmaEliminar(false)">
                <mdb-modal-header>
                    <mdb-modal-title>Eliminar</mdb-modal-title>
                </mdb-modal-header>
                <mdb-modal-body>¿Está seguro que desea eliminar esta auditoria?</mdb-modal-body>
                <mdb-modal-footer>
                    <button class="btn btn-danger btn-sm" @click="confirmaEliminar(false)">Cancelar</button>
                    <button class="btn btn-primary btn-sm" @click="confirmaEliminar(true)">Confirmar</button>
                </mdb-modal-footer>
            </mdb-modal>
            <mdb-modal size="sm" :show="this.modalVerificacion.estado" @close="confirmaVerificar(false)">
                <mdb-modal-header>
                    <mdb-modal-title>Verificación</mdb-modal-title>
                </mdb-modal-header>
                <mdb-modal-body>¿Está seguro que desea confirmar esta auditoria?</mdb-modal-body>
                <mdb-modal-footer>
                    <button class="btn btn-danger btn-sm" @click="confirmaVerificar(false)">Cancelar</button>
                    <button class="btn btn-primary btn-sm" @click="confirmaVerificar(true)">Confirmar</button>
                </mdb-modal-footer>
            </mdb-modal>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
export default {
    name: 'Admin',
    computed:{
        ...mapState(['usuario', 'noVerificadas'])
    },
    methods:{
        ...mapActions(['getNoVerificadas', 'eliminarAuditoria', 'verificarAuditoria']),
        confirmaEliminar: function (eliminar) {
            if (eliminar === true) {
                this.eliminarAuditoria(this.modal.item);
                this.getNoVerificadas();
                this.modal.estado = false;
                this.modal.item = 0;
            } else {
                this.modal.estado = false;
                this.modal.item = 0;
            }
        },
        confirmaVerificar: function (confirmar) {
            if (confirmar === true) {
                this.verificarAuditoria(this.modalVerificacion.item);
                this.modalVerificacion.estado = false;
                this.modalVerificacion.item = 0;
            } else {
                this.modalVerificacion.estado = false;
                this.modalVerificacion.item = 0;
            }
        }
    },
    created(){
        this.getNoVerificadas()
    },
    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
    },
    data() {
      return {
        modal: {
            estado: false,
            item: 0
        },
        modalVerificacion: {
            estado: false,
            item: 0
        }
      };
    }
  }
</script>
<style scoped>
.listaAcciones {
    display: flex;
}
.btnTableEliminar {
    cursor: pointer;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    color: whitesmoke;
    background-color: rgba(236, 62, 31, 0.8);
}

 .btnTableVer {
    cursor: pointer;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    color: whitesmoke;
    background-color: rgba(57, 92, 162, 0.8);
}

.btnTableConfirmar {
    cursor: pointer;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    color: whitesmoke;
    background-color: rgba(48, 223, 48, 0.8);
}

.conNotas {
    cursor: default;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    color: whitesmoke;
    background-color: rgba(17, 212, 103, 0.8);
    }

.sinNotas {
    cursor: default;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    color: whitesmoke;
    background-color: rgba(251, 146, 19, 0.8);
    }


@media (max-width: 450px) {
    
    .btnTableEliminar {
    cursor: pointer;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    font-size: 0.80em;
    color: whitesmoke;
    background-color: rgba(236, 62, 31, 0.8);
}

 .btnTableVer {
    cursor: pointer;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    font-size: 0.80em;
    color: whitesmoke;
    background-color: rgba(57, 92, 162, 0.8);
}

.btnTableConfirmar {
    cursor: pointer;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    font-size: 0.80em;
    color: whitesmoke;
    background-color: rgba(48, 223, 48, 0.8);
}

.conNotas {
    cursor: default;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    font-size: 0.80em;
    color: whitesmoke;
    background-color: rgba(17, 212, 103, 0.8);
    }

.sinNotas {
    cursor: default;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    font-size: 0.80em;
    color: whitesmoke;
    background-color: rgba(251, 146, 19, 0.8);
    }
    }

@media (max-width: 340px) {
    
    .btnTableEliminar {
    cursor: pointer;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    font-size: 0.70em;
    color: whitesmoke;
    background-color: rgba(236, 62, 31, 0.8);
}

 .btnTableVer {
    cursor: pointer;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    font-size: 0.70em;
    color: whitesmoke;
    background-color: rgba(57, 92, 162, 0.8);
}

.btnTableConfirmar {
    cursor: pointer;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    font-size: 0.70em;
    color: whitesmoke;
    background-color: rgba(48, 223, 48, 0.8);
}

.conNotas {
    cursor: default;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    font-size: 0.70em;
    color: whitesmoke;
    background-color: rgba(17, 212, 103, 0.8);
    }

.sinNotas {
    cursor: default;
    width: 24%;
    margin: 0.1rem;
    text-align: center;
    font-size: 0.70em;
    color: whitesmoke;
    background-color: rgba(251, 146, 19, 0.8);
    }
    }
</style>